import moment from "moment";

export const parseDate = (dateStr) => new Date(dateStr);

export const formatUtcDateToLocal = (utcDate, formatter) =>
  moment.utc(utcDate).local().format(formatter);

export const formatLocalDateToUtc = (localDate) => moment.utc(localDate).valueOf();

export const differenceInDays = (date1, date2) => {
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());
  return Math.abs(Math.floor((utc2 - utc1) / _MS_PER_DAY));
};

export const unixInstantToMilliseconds = (unixTimestamp) => {
  return unixTimestamp * 1000;
};
